// import { useAtom } from "jotai";
// import {
//   popupTaskAtom,
//   showPopupAtom,
// } from "../_helper/constant/constant-atom";
import { useEffect, useState } from "react";

const useReminder = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [popupTask, setPopupTask] = useState(null);

  const formatTime = (date) =>
    date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });

  const [ctime, setCtime] = useState(formatTime(new Date()));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCtime(formatTime(new Date()));
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const checkTaskTime = (task) => {
    if (task.time === ctime) {
      setPopupTask(task);
      setShowPopup(true);
    }
  };

  useEffect(() => {
    const tasks = JSON.parse(localStorage.getItem("tasks"));
    if (tasks) {
      tasks?.map((task) => {
        checkTaskTime(task);
      });
    }
  }, [ctime]);

  return {
    isReminder: showPopup && popupTask,
    popupTask,
    setShowPopup: setShowPopup,
  };
};

export default useReminder;
